// extracted by mini-css-extract-plugin
module.exports = {"list-price-strikethrough":"plan-price_list-price-strikethrough__7fgAW"};